export function incompleteEmail(value: string): boolean {
  const at = value.trim().lastIndexOf('@');
  if (at < 1) return true;
  const domain = value.trim().slice(at + 1);
  const dot = domain.lastIndexOf('.');
  return dot < 1 || dot > domain.length - 3;
}
